import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "notification-settings"
};
const _hoisted_2 = { class: "form__label-wrapper" };
const _hoisted_3 = { class: "form__label form__label--required" };
const _hoisted_4 = { class: "form__control-wrapper" };
const _hoisted_5 = { class: "form__buttons notification-settings__buttons" };
const _hoisted_6 = ["disabled"];
import { ref } from "vue";
import config from '@astina/paloma-shop-portal-ui/src/services/ConfigRepository';
import trans from '@astina/paloma-common-ui/src/services/Translator';
import alerts from "@astina/paloma-common-ui/src/services/Alerts";
export default /*@__PURE__*/ _defineComponent({
    __name: 'WatchlistOrderNotificationSettings',
    props: {
        watchlist: {},
        saved: { type: Boolean }
    },
    setup(__props) {
        const phoneNumber = ref('');
        const hasPhoneNumberConfigured = ref(true);
        loadSettings();
        function loadSettings() {
            config.getNotificationSettingsForm()
                .then(form => {
                hasPhoneNumberConfigured.value = !!form.data.notifications.find(setting => {
                    return setting.phoneNumber && setting.orderOrigins.find(origin => origin === 'portal_watchlist');
                });
            });
        }
        function phoneNumberInvalid() {
            const phoneNumberLocal = phoneNumber.value.trim();
            if (!phoneNumberLocal) {
                return;
            }
            return !phoneNumberLocal.match(/^\+?[\d ]{10,17}$/);
        }
        function save() {
            if (phoneNumberInvalid()) {
                return;
            }
            const phoneNumberLocal = phoneNumber.value.trim();
            config.getNotificationSettingsForm()
                .then(form => {
                const settings = form.data;
                settings.notifications.push({
                    phoneNumber: phoneNumberLocal,
                    orderOrigins: ['portal_watchlist'],
                    types: ['ORDER_CONFIRMATION'],
                });
                config.saveNotificationSettings(settings)
                    .then(() => alerts.success(trans('customer_notifications_settings.save.success')))
                    .then(loadSettings);
            });
        }
        return (_ctx, _cache) => {
            return (!hasPhoneNumberConfigured.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t('watchlist_order_notification.text')), 1),
                    _cache[3] || (_cache[3] = _createTextVNode()),
                    _createElementVNode("form", {
                        onSubmit: _withModifiers(save, ["prevent"]),
                        class: "form form--simple notification-settings__form"
                    }, [
                        _createElementVNode("div", {
                            class: _normalizeClass(["form__group form__group--required notification-settings__control", { 'form__group--invalid': phoneNumberInvalid() }])
                        }, [
                            _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('contact.phoneNumber')), 1)
                            ]),
                            _cache[1] || (_cache[1] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_4, [
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((phoneNumber).value = $event)),
                                    pattern: "+?[0-9 ]{10-17}",
                                    type: "text",
                                    class: "form__control"
                                }, null, 512), [
                                    [_vModelText, phoneNumber.value]
                                ])
                            ])
                        ], 2),
                        _cache[2] || (_cache[2] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("button", {
                                type: "submit",
                                class: "button",
                                disabled: !phoneNumber.value || phoneNumberInvalid()
                            }, _toDisplayString(_ctx.$t('save')), 9, _hoisted_6)
                        ])
                    ], 32)
                ]))
                : _createCommentVNode("", true);
        };
    }
});
